module.exports = __webpack_public_path__ + "static/media/MapOff.ef754de7.svg";